import { Strings } from "src/modules/utils/shared/strings";

export class Company {
    id = 0;
    name = "";
    sortName = "";
    useUserGroupLevel = true;

    getStringRepresentation(): string {
        return this.name;
    }

    getSortName(): string {
        return Strings.def(this.sortName, this.name);
    }
}